import { useSelector } from '../../hooks';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { GeodesistList } from '../../geodesists/components/GeodesistList';
import { ManagerMenu } from '../../manager/managermenu';

import { Error, ERROR_TYPE } from '../components/Error';

const ManagerGeodesistListPage = () => {
  const { manager, apps } = useSelector((state) => state.app.config);
  return (
    <>
      {apps?.manager && manager?.modules?.geodesists ? (
        <AppWrapper
          appType={APP_TYPE.MANAGER}
          menu={<ManagerMenu />}
          resource='Geodesists'
          action='list.view'
        >
          <GeodesistList />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default ManagerGeodesistListPage;
